import client from './client';

export interface LoginResponse {
  token: string;
  user: { id: number; name: string; email: string };
}

export async function apiLogin(email: string, password: string): Promise<LoginResponse> {
  const res = await client.post<LoginResponse>('/auth/login', { email, password });
  return res.data;
}

export async function apiMe(): Promise<LoginResponse['user']> {
  const res = await client.get<LoginResponse['user']>('/auth/me');
  return res.data;
}
